import { render, staticRenderFns } from "./MultipleAvatar.vue?vue&type=template&id=9b872984&scoped=true"
import script from "./MultipleAvatar.vue?vue&type=script&lang=js"
export * from "./MultipleAvatar.vue?vue&type=script&lang=js"
import style0 from "./MultipleAvatar.vue?vue&type=style&index=0&id=9b872984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b872984",
  null
  
)

export default component.exports